import React from "react";
import { DialogContent, DialogTitle, Grid, IconButton, TextField, Typography } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import withIntl from "../../utils/withIntl";

function SelectElementDialog(props) {
  const [customText, setCustomText] = React.useState("");
  const elementView = (children) => {
    return (
      <div
        style={{
          borderRadius: 30,
          border: "1px solid grey",
          backgroundColor: "#EEE",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 4px",
        }}
      >
        {children}
      </div>
    );
  };

  const gridElement = (type) => {
    return (
      <>
        <Grid item xs={8}>
          {elementView(<Typography>{props.intl.formatMessage({ id: "print_element_" + type })}</Typography>)}
        </Grid>
        <Grid item xs={4}>
          <IconButton
            size={"small"}
            onClick={() => {
              props.onSelect(type);
            }}
          >
            <Add />
          </IconButton>
        </Grid>
      </>
    );
  };

  return (
    <>
      <DialogTitle>Select element</DialogTitle>
      <DialogContent>
        <Grid container>
          {gridElement("count")}
          {gridElement("price")}
          {gridElement("print_name")}
          {gridElement("article_name")}
          {gridElement("end_align")}
          {gridElement("money_sign")}
          <Grid item xs={8}>
            <TextField
              placeholder={"Custom text"}
              value={customText}
              onChange={(e) => {
                setCustomText(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <IconButton
              size={"small"}
              onClick={() => {
                props.onSelect(customText);
              }}
            >
              <Add />
            </IconButton>
          </Grid>
        </Grid>
      </DialogContent>
    </>
  );
}

export default withIntl(SelectElementDialog);
